import * as React from "react";

const BeforeDuringAfter: React.FC = ({ children }) => (
    <>
	<section id="venue-hero" className="venue-hero-short">
      <div className="cover-shape"></div>
      <div className="content-container maxw1350">
        <h1>Before - During - After</h1>
        <p>How to Use TacBoard for Each Stage of Your Event.</p>
      </div>
      <div className="bottom-wave"></div>
    </section>

	<section className="includes before-your-event" id="phone">
      <h2 className="center">
        <span className="line"></span>Before Your Event<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
          <picture className="med-img">
            <source type="image/webp" srcSet="
                img/how-step1-1xt.webp,
                img/how-step1-2xt.webp 1.5x,
                img/how-step1-2xt.webp 2x
              " />
            <source type="image/jpg" srcSet="
                img/how-step1-1xt.jpg,
                img/how-step1-2xt.jpg 1.5x,
                img/how-step1-2xt.jpg 2x
              " />
            <img src="img/how-step1-1xt.jpg" alt="TacBoard Receive Phone Number" />
          </picture>
        </div>
        <div className="half">
          <p>
            Sign up anytime within a year of your event and instantly receive your unique phone number, online gallery, and live photo stream.
		</p><p>
You'll be able to begin using TacBoard right away and your phone number won't expire until 30 days after your event date. 
</p><p>
Be sure to share your unique phone number with your friends and family, and it's always fun to text some of your favorite photos before your main event to have them streaming as everyone walks in!
		</p>
        </div>
      </div>
      <div className="bottom-wave-cream"></div>
    </section>

	<section id="setup" className="creambg">
      <h2 className="center">
        <span className="line"></span>During Your Event<span className="line"></span>
      </h2>
      <h3 className="center">
        Set up your Live Photo Stream
      </h3>
      <div className="steps maxw1350">
        <div className="quarter setup-step">
          <div className="stpe-vid-box">
            <video disableRemotePlayback className="easy-breezy-vid" autoPlay muted loop preload="none">
              <source src="img/av-Setup-s2.webm" type="video/webm" />
              <source src="img/av-Setup-s2.mp4" type="video/mp4" />
            </video>
          </div>
          <span>
            <h4>1</h4>
            <p>
              Connect a laptop to a projector (or TV) with an HDMI cable or
              similar.
            </p>
          </span>
        </div>
        <div className="quarter setup-step">
          <div className="stpe-vid-box">
            <img src="img/wifi.gif" />
          </div>
          <span>
            <h4>2</h4>
            <p>
              On the laptop, access the venue’s Wi-Fi network or your hotspot.
            </p>
          </span>
        </div>
        <div className="quarter setup-step">
          <div className="stpe-vid-box">
            <video disableRemotePlayback className="easy-breezy-vid" autoPlay muted loop preload="none">
              <source src="img/a_v-go-to-live-display.webm" type="video/webm" />
              <source src="img/a_v-go-to-live-display.mp4" type="video/mp4" />
            </video>
          </div>
          <span>
            <h4>3</h4>
            <p>
              While logged into your TacBoard account, simply select “Display
              Live."
            </p>
          </span>
        </div>
      </div>
      <h3>
        Need to rent a projector and screen for your event? Contact your DJ or venue today!
      </h3>

      <div className="bottom-wave"></div>
    </section>

	<section className="includes" id="gallery">
      <h2 className="center">
        <span className="line"></span>After Your Event<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
          <picture>
            <source type="image/webp" srcSet="
                img/any-device-dx1.webp,
                img/any-device-dx2.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/any-device-mx1.webp,
                img/any-device-mx2.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/any-device-dx1.jpf,
                img/any-device-dx2.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/any-device-mx1.jpf,
                img/any-device-mx2.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/png" srcSet="
                img/any-device-dx1.png,
                img/any-device-dx2.png 2x
              " media="(min-width: 801px)" />
            <source type="image/png" srcSet="
                img/any-device-mx1.png,
                img/any-device-mx2.png 2x
              " media="(max-width: 800px)" />

            <img src="/img/any-device-dx1.png" alt="alt description" />
          </picture>
        </div>
        <div className="half">
          <p>
            30 days after your event, your unique phone number will be deactivated. But you’ll still be able to view, share, and download your photos. 
          </p>
        </div>
      </div>
    </section>
    </>
)

export default BeforeDuringAfter;
